































import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
  props: {
    tabNo: {
      type: Number as PropType<number>,
      required: true
    },
  },
  setup(props, context){

    const toRoomList = () => {
      context.root.$router.push(`/teacher_site/room_list`);
    };
    
    const toClassNameList = () => {
      context.root.$router.push(`/teacher_site/classifcation_list`);
    };

    const toCourseList = () => {
      context.root.$router.push(`/teacher_site/course_list`);
    };

    const toCramStudentList = () => {
      context.root.$router.push(`/teacher_site/cram_student_list`);
    };

    const toEventList = () => {
      context.root.$router.push(`/teacher_site/event_list`);
    };

    const toCurriculumList = () => {
      context.root.$router.push(`/teacher_site/curriculum_list`);
    };

    const toUpload = () => {
      if(props.tabNo == 1){
        context.root.$router.push(`/teacher_site/room_upload`);
      }else if(props.tabNo == 2){
        context.root.$router.push(`/teacher_site/classifcation_upload`);
      }else if(props.tabNo == 3){
        context.root.$router.push(`/teacher_site/course_upload`);
      }else if(props.tabNo == 4){
        context.root.$router.push(`/teacher_site/cram_student_upload`);
      }else if(props.tabNo == 5){
        context.root.$router.push(`/teacher_site/event_upload`);
      }else if(props.tabNo == 6){
        context.root.$router.push(`/teacher_site/curriculum_upload`);
      }
    };

    return {
      toRoomList,
      toClassNameList,
      toCramStudentList,
      toCourseList,
      toEventList,
      toCurriculumList,
      toUpload,
    };
  }
})
